module.exports = __webpack_public_path__ + "img/title-bg.53375d02.png";